import script from "./DetailProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailProgram.vue?vue&type=script&setup=true&lang=js"

import "./DetailProgram.vue?vue&type=style&index=0&id=7a840806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a840806"]])

export default __exports__